import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { Title, Meta } from '@angular/platform-browser';


@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css', '../../commercial.component.css']
})
export class AboutComponent implements OnInit {
  showHelp = false;
  constructor(private router: Router, private residentialService: ResidentialService,private title: Title,private meta: Meta) { }

  ngOnInit() {
    this.title.setTitle('Receive Custom Energy Quotes Based on Your Business Needs and Usage Profile');
    this.meta.updateTag({name: 'keywords', content: 'commercial energy,business energy,reverse auction,negotiation,representation,fixed rate,variable rate,index rate,blend and extend,free bill analysis,energy contract management,energy roadmap,energy broker,energy advisor,energy consultant,experienced energy expert,business owner,retail store front,shopping center,restaurant chain,energy procurement,free analysis,energy supply,energy strategy,ways to decrease overhead,custom pricing'});
    this.meta.updateTag({name: 'description', content: 'Free commercial energy bill analysis. Expert advice. Honest recommendations. Leverage Honest Gorilla’s purchasing power and portfolio to your financial gain.'});
    this.meta.updateTag({name: 'author', content: 'HonestGorilla'});
    this.meta.updateTag({name: 'robots', content: 'index, follow'});
  }

  checkoutRates() {
    this.router.navigateByUrl('/commercial/get-started');
  }
  closebootvideo() {}

  help() {
    this.showHelp = true;
    this.residentialService.setHelpFlag({flag: true});
    this.residentialService.loadScriptFiles('../../../../assets/js/custom.js');
  }

}
